/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { Routes, RouterModule } from '@angular/router';
import { MotionComponent } from './motion/motion.component';


const routes: Routes = [
  { 
      path: 'motion',
      children:[
          { path: ':unit/:plc/:entries' , component: MotionComponent },
          { path: ':unit/:plc' , component: MotionComponent },
          { path: ':unit' , component: MotionComponent },
      ]
  }
];

export const MOTION_ROUTES = RouterModule.forChild(routes);